module.exports = "<div class=not-have-organization> <no-organization-card></no-organization-card> </div> ";